export type PolicyholderState = {
  showSideMenu: boolean;
};

export const initialPolicyholderState: PolicyholderState = {
  showSideMenu: false,
};
